<script>
	import { Table, DropdownItem } from "sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { convert } from "../../../services/helpers";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let totalPages;
	export let handleUserStatus;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>First Name</th>
				<th>Last Name</th>
				<th>Mobile No.</th>
				<th>Email.</th>
				<th>Created at</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, firstName, lastName, mobile, email, createdAt, isEnabled, roleId, designation, department }}
				<tr>
					<td>
						<p>
							<span>
								{firstName}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{lastName}
							</span>
						</p>
					</td>
					<td>
						+65{mobile}
					</td>
					<td>
						{#if email == undefined}
							<p class="mx-5">-</p>
						{:else}
							{email}
						{/if}
					</td>
					<td>
						{convert(createdAt)}
					</td>

					<td>
						{#if isEnabled}
							<p class="status-bar status-bar-1">Active</p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() =>
									navigate(
										`/account/fms-account-management/edit/${id}`
									)}>Edit</DropdownItem
							>

							{#if !isEnabled}
								<DropdownItem
									on:click={() => handleUserStatus(id, true)}
									>Set as Active</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() => handleUserStatus(id, false)}
									>Set as Inactive</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.length} {totalPages} />
</LoaderContainer>
